<template>
  <Page :rounded="false">
    <div class="flex w-full justify-center bg-white py-6">
      <img :src="branding.logoPrimary" :alt="branding.appName" class="h-8" />
    </div>
    <ContentBanner
      variant="pageError"
      title="This page is Unavailable"
      message="It may have been deactivated or deleted by an admin. Please contact your admin for assistance."
      class="mt-64!"
    />
  </Page>
</template>

<script setup>
import { ContentBanner } from '@dashhudson/dashing-ui/content-banner';
import { Page } from '@dashhudson/dashing-ui/page';
import { Section } from '@dashhudson/dashing-ui/section';

import { branding } from '@/config';
</script>
